import { useContext, useEffect } from 'react';
import Context from '../provider';

/**
 * Custom Hook to detect if an element is scrolling
 * @returns {number} Whether the element is currently scrolling
 */
function useSetHtmlHeader(headerInfo) {
  const { init, program } = useContext(Context);

  useEffect(() => {
    if (init && program) {
      console.log('useSetHtmlHeader', headerInfo);
      if (headerInfo.themeColor)
        document.querySelector('meta[name="theme-color"]')
          .setAttribute('content', headerInfo.themeColor);
    }

  }, [init, program]);
}

export default useSetHtmlHeader;